<template>
  <div class="analysis-score-page">
    <!--    客户满意度    -->
    <div class="entity-wrap">
      <!--      时间选择      -->
      <timeSelect class="time-select" @screen="screen"></timeSelect>

      <div class="progress-view-wrap">
        <!--       柱状图     -->
        <progressBarchart
          class="progress-view"
          :title="item.title"
          v-for="(item, index) in arrServicePowerEvaScoreList"
          :key="index"
          :score="item.score"
          :resultList="item.EvaScoreList"
        ></progressBarchart>
      </div>
    </div>

    <!--    全国评分    -->
    <div class="entity-wrap">
      <!--       折线图     -->
      <brokenLineChart title="全国冷暖风水服务综合能力月度评分" :resultList="arrMothScoreList"></brokenLineChart>
    </div>
  </div>
</template>

<script>
import timeSelect from "@/components/timeSelect/index";
import progressBarchart from "@/page/service/components/progressbarchart";
import brokenLineChart from "@/page/service/components/brokenlinechart";
import { getEarthPercentage, getEarthMonth } from "@/js/service";
import {fetchVerifyAuthForB} from '@/libsV2/havc.js';

import { mapState } from "vuex";

export default {
  name: "score",
  components: {
    timeSelect,
    progressBarchart,
    brokenLineChart,
  },
  data(){
      return{
      }
  },
  created(){

  },
  mounted() {
     fetchVerifyAuthForB(()=>{
        // this.getPercentage()//放在时间组件里面调用初始化
        this.getMonthPercentage()
    })
    // $init(() => {
    //   this.$store.commit("loadSwitch", true);
    //   Promise.all([this.getPercentage(), this.getMonthPercentage()]).then((res) => {

    //   });
    // });
  },
  computed: {
    ...mapState({
      // 全国冷暖风水服务能力评分-满意度
      arrServicePowerEvaScoreList: (state) => state.serviceCustomerScoring.arrServicePowerEvaScoreList,
      // 月度评分数组
      arrMothScoreList: (state) => state.serviceCustomerScoring.arrMothScoreList,
    }),
  },
  methods: {
    // 获取柱形图数据
    getPercentage(startTime, endTime) {
        this.$store.commit("loadSwitch", true);
      getEarthPercentage({ start_time: startTime, end_time: endTime }).then((res) => {
                  this.$store.commit("loadSwitch", false);
        let result = res.data.data.result;
        let dataArr = [
          {
            title: "全国冷暖风水服务能力评分",
            score: parseFloat(result.service_list.score),
            EvaScoreList: [
              {
                id: result.service_list.air_condition_system.project_id,
                name: "空调系统施工与安装",
                value: result.service_list.air_condition_system.score,
              },
              {
                id: result.service_list.wall_furnace_system.project_id,
                name: "壁挂炉系统施工与安装",
                value: result.service_list.wall_furnace_system.score,
              },
              {
                id: result.service_list.primary_air_system.project_id,
                name: "新风系统施工与安装",
                value: result.service_list.primary_air_system.score,
              },
              {
                id: result.service_list.transition_issues.project_id,
                name: "交接问题",
                value: result.service_list.transition_issues.score,
              },
              {
                id: result.service_list.system_debug.project_id,
                name: "系统调试能力",
                value: result.service_list.system_debug.score,
              },
              {
                name: "竣工交付质量",
                id: result.service_list.delivery_quality.project_id,
                value: result.service_list.delivery_quality.score,
              },
              {
                name: "系统材料使用规范",
                id: result.service_list.material_use.project_id,
                value: result.service_list.material_use.score,
              },
              {
                id: result.service_list.draw_application.project_id,
                name: "图纸应用",
                value: result.service_list.draw_application.score,
              },
              {
                id: result.service_list.live_safe.project_id,
                name: "现场安全",
                value: result.service_list.live_safe.score,
              },
              {
                id: result.service_list.proficiency_use.project_id,
                name: "艾暖通使用熟练度",
                value: result.service_list.proficiency_use.score,
              },
            ],
          },
          {
            title: "客户满意度评分",
            score: parseFloat(result.customer_list.score),
            EvaScoreList: [
              {
                name: "销售体验满意度",
                value: result.customer_list.sale_score,
              },
              {
                name: "系统设计满意度",
                value: result.customer_list.sign_score,
              },
              {
                name: "系统施工满意度",
                value: result.customer_list.work_score,
              },
              {
                name: "监理验收满意度",
                value: result.customer_list.delivery_score,
              },
              {
                name: "服务效率满意度",
                value: result.customer_list.service_score,
              },
            ],
          },
        ];
        this.$store.commit("editServiceCustomerScoring", dataArr.slice(0,1));
        // 判断柱形图是否有数据
        let arrFilterData = dataArr[0].EvaScoreList.filter((it)=>{
            return it.value>0
        })
          if(arrFilterData.length==0){
              this.$toast('该时间段没有评分~')
          }
        console.log(arrFilterData,'EvaScoreList')
      });
    },
    // 月度评分折线图数据
    getMonthPercentage() {
      getEarthMonth().then((res) => {
        let newArrServe = [];//项目服务评分
        // let newArrSatisfied = [];//用户满意评分
        // let newArrComprehensive = [];//综合评分
        res.data.data.result.list.forEach((element) => {
          for (const key in element.list) {
          // 服务能力评分处理
            let objServer = {};
            if (key === "service_score") {
              objServer.type = "项目服务评分";
              let str = element.month.slice(-2);
              if (str.slice(0, 1) === "0") {
                str = str.slice(-1);
              }
              objServer.data = str;
              objServer.value =parseFloat(element.list[key]);
              newArrServe.push(objServer);
            }
          }
        });
        // 服务能力评分月份补充以及加'月'字符串
        for(let i =newArrServe.length+1;i<=12;i++){
            let obj ={data: i,type: "项目服务评分",value: 0}
            newArrServe.push(obj)
        }
        let newArrServeData=newArrServe.map(it=>{
          it.data=it.data+'\n月'
          return it
        })

        this.$store.commit("editMonthScore", newArrServeData);
      });
    },
    // 获取时间
    screen(e) {
      this.getPercentage(e.sStartTime === "开始时间" ? "" : e.sStartTime+' 00:00:00', e.sEndTime === "结束时间" ? "" : e.sEndTime+" 23:59:59");
    },
  },
};
</script>

<style scoped lang="scss">
.analysis-score-page {
  padding-top: 24px;

  .entity-wrap {
    padding: 32px 24px 4px;
    background: #ffffff;
    border-radius: $commonRadius;
    margin-bottom: 24px;

    .time-select {
      margin-bottom: 20px;
    }

    .progress-view-wrap {
      .progress-view {
        padding-bottom: 10px;
        margin-top: 20px;
        background: linear-gradient(to right, rgba(#f1f1f1, 1) 50%, transparent 50%) repeat-x left bottom / 16px 2px;

        &:nth-child(2) {
          margin-top: 18px;
          padding-bottom: 4px;
        }

        &:last-of-type {
          background: none;
        }
      }
    }
  }
}
</style>
